const shape = {
  borderRadiusSm: "4px",
  borderRadius: "8px",
  borderRadiusMd: "20px",
  newBorderRadius: "16px"
};

export default shape;
